"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircularIcon = void 0;
// external
const React = require("react");
// local
const Icon_1 = require("../Icon");
const colors_1 = require("../../../../types/colors");
// css
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles);
/**
 * Component that renders icons in a circular button
 */
const CircularIcon = (_a) => {
    var { isActive = false, disabled = false, size = "", className = "", variant = colors_1.TColorVariants.None, onClick } = _a, rest = __rest(_a, ["isActive", "disabled", "size", "className", "variant", "onClick"]);
    const classNames = css("circularIcon", `-stdSize-${size}`, `-color-${variant}`, { "-color-active": isActive, "-color-disabled": disabled, className });
    return (React.createElement(Icon_1.Icon, Object.assign({ className: classNames, onClick: disabled ? null : onClick }, rest)));
};
exports.CircularIcon = CircularIcon;
exports.default = exports.CircularIcon;
//# sourceMappingURL=index.js.map